import * as React from "react";
const SvgArrowForward = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M12 4l-1.4 1.4 5.58 5.6H4v2h12.17l-5.58 5.6L12 20l8-8z" }));
export default SvgArrowForward;
